import loadable from "@loadable/component";
import { memo } from "react";
import { Helmet } from "react-helmet";
import TrustPilotReviewsBanner from "@Pages/Search/components/SearchList/components/TrustPilotBanner";
import CollectionRailsGroup from "../components/CollectionRailsGroup";
import PreviouslyViewed from "../components/PreviouslyViewed";
import BookYourPerfectAccommodation from "../components/BookYourPerfectAccommodation";
import ThreeStepsSection from "../components/ThreeStepsSection";
import HundredsOfCities from "../components/HundredsOfCities";
import ReferralProgram from "../components/ReferralProgram";
import ListWithUs from "../components/ListWithUs";
import GetHelpDesktop from "../components/GetHelpDesktop";
import PartnerReferSection from "../components/PartnerReferSection/index";
import FooterDesktop from "@Components/FooterV2/FooterDesktop";
import config from "@Config/index";
// import generateHreflangUrls from "@Utils/generateHreflangUrls"; // temporarily unused — re-enable with hreflang render below
import { generateCanonicalUrl } from "@Utils/generateHreflangUrls";
// import { isNoindexLang } from "@Utils/languageCore";
import AnnouncementBanner from "@Components/AnnouncementBanner";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import BestPartners from "../components/BestPartners";
import ReferredByCard from "../components/ReferredByCard/ReferredByCard";
import HeroSectionDesktop from "../components/HeroSectionDesktop";
import AmberCopilotWrapper from "@Components/Chatbot/AmberCopilotWrapper";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";

const ZendeskChat = loadable(() => import("@Pages/PropertyPage/components/ZendeskChat"), {
  ssr: false,
});

const HomeDesktop = (): JSX.Element => {
  const { t } = useTranslationHook();
  const pageTitle = t("Discover the Best Student Accommodation and Housing | Amber");
  const { userLanguage } = useSelector(
    ({ appData }: AppState) => ({
      userLanguage: appData.userLanguage,
    }),
    shallowEqual,
  );
  return (
    <div>
      <Helmet title={pageTitle}>
        <meta
          name="description"
          content={t(
            "Browse from 10000+ student accommodations, apartments, and rooms with verified reviews, photos and amenities. Find your perfect home away from home with Amber. Book now!",
          )}
        />
        <meta name="name" content="Discover the Best Student Accommodation and Housing | Amber" />
        {["en", "zh"].includes(userLanguage) && (
          <meta
            name="keywords"
            content={t(
              "Amberstudent, amberstudent.com, student accommodation, student housing, student apartments, off campus, private halls, homestays",
            )}
          />
        )}
        <link rel="canonical" href={generateCanonicalUrl(config.WEB_SERVICE_URL, userLanguage)} />
        {/* Hreflang temporarily disabled site-wide (including en / x-default)
        {!config.IS_CHINA_APP &&
          !isNoindexLang(userLanguage) &&
          generateHreflangUrls(config.WEB_SERVICE_URL).map(({ hreflang, href }) => (
            <link key={hreflang} rel="alternate" hrefLang={hreflang} href={href} />
          ))}
        */}
      </Helmet>
      <HeroSectionDesktop />
      <ReferredByCard />
      <AnnouncementBanner />
      <PartnerReferSection />
      <PreviouslyViewed isDesktop />
      <CollectionRailsGroup isDesktop />
      <TrustPilotReviewsBanner isHomePage isDesktop uniCity={null} />
      <BookYourPerfectAccommodation isDesktop />
      <ReferralProgram isDesktop />
      <ThreeStepsSection isDesktop />
      <BestPartners isDesktop />
      <ListWithUs isDesktop />
      <HundredsOfCities isDesktop />
      <GetHelpDesktop />
      <FooterDesktop />
      <ZendeskChat />
      <AmberCopilotWrapper />
    </div>
  );
};

export default wrapperHOC(memo(HomeDesktop), {
  componentName: "HomeDesktop",
  showForChina: true,
});
